import { createFileRoute } from '@tanstack/react-router'

import { RoleTemplatesPage } from '#/modules/roles/role-templates-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/role-templates/')({
  component: RoleTemplatesPage,
  validateSearch: validateListSearch,
})
